import { useDispatch, useSelector } from 'react-redux';
import { useDeliveryHours } from '@mafc/common';
import {
  fetchSubstitutes,
  updateOOSCurrentItemIndex,
  updateOOSSelectedItems,
} from '../redux/actions/substitutes.action';
import useDrawerControls from 'hooks/useDrawerControls';
import { IAppState } from 'config/redux/reducers';
import { useCallback, useEffect } from 'react';
import { isUndefined } from 'utils/helpers.util';
import TrackerSubstitution from 'utils/Tracker.substitution';
import { fetchCart } from '../redux/actions/fetchCart.actions';

const useOOSCartList = ({ shipmentType }: { shipmentType: string }) => {
  const dispatch = useDispatch();

  const { isOpen: isChooseSubstitutesDrawerOpen, openDrawer, closeDrawer } = useDrawerControls();
  const {
    isOpen: isSelectSubstitutesDrawerOpen,
    openDrawer: openSelectSubstitutesDrawer,
    closeDrawer: closeSelectSubstitutesDrawer,
  } = useDrawerControls();

  const { isNowUnavailableHour } = useDeliveryHours();

  const { substitutes, oosSelectedItemsIds, oosCurrentItemIndex } = useSelector(
    (state: IAppState) => state.newCart
  );

  const substitutesShipment = substitutes.find(s => s.shipmentType === shipmentType);

  const currentOOSProductId = oosSelectedItemsIds[oosCurrentItemIndex];

  const refreshSubstitutes = () => {
    dispatch(fetchSubstitutes(isNowUnavailableHour));
  };

  const closeChooseSubstitutesDrawer = useCallback(() => {
    dispatch(updateOOSSelectedItems([]));
    dispatch(updateOOSCurrentItemIndex(0));
    dispatch(fetchCart(refreshSubstitutes));
    closeDrawer();
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openChooseSubstitutesDrawer = () => {
    if (substitutesShipment && substitutesShipment.eligibleItems) {
      const ids = substitutesShipment.eligibleItems.map(item => item.originalProduct.entryNumber);
      // updating only when eligible item is one, means user is coming directly on choose substitute drawer not via select substitute drawer
      if (ids.length === 1) {
        dispatch(updateOOSSelectedItems(ids));
      }

      openDrawer();
    }
  };

  useEffect(() => {
    if (isUndefined(currentOOSProductId) && isChooseSubstitutesDrawerOpen) {
      closeChooseSubstitutesDrawer();
    }
  }, [currentOOSProductId, isChooseSubstitutesDrawerOpen, closeChooseSubstitutesDrawer]);

  const onContinueAfterSelectingProducts = (selectedProductIds: number[]) => {
    dispatch(updateOOSSelectedItems(selectedProductIds));
    closeSelectSubstitutesDrawer();
    openChooseSubstitutesDrawer();
    TrackerSubstitution.selectSubstituteReplaceBtnTracking();
  };

  const shipmentReplaceOnClick = () => {
    if (
      substitutesShipment &&
      substitutesShipment.eligibleItems &&
      substitutesShipment.eligibleItems.length > 1
    ) {
      openSelectSubstitutesDrawer();
    } else {
      openChooseSubstitutesDrawer();
    }
    TrackerSubstitution.shipmentReplaceBtnTracking();
  };

  return {
    substitutesShipment,
    isChooseSubstitutesDrawerOpen,
    closeChooseSubstitutesDrawer,
    isSelectSubstitutesDrawerOpen,
    closeSelectSubstitutesDrawer,
    shipmentReplaceOnClick,
    onContinueAfterSelectingProducts,
    refreshSubstitutes,
  };
};

export default useOOSCartList;
